import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ContentUrls = ({ urls }) => {
    const isPathActive = (path) => {
        return window.location.pathname.startsWith(path);
    }

    return (
        <div className="col-md-12">
        <ul style={{width:'100%'}}>
            {
                urls.map((data) => (
                    <li key={data.to} className="nav-item">
                        {" "}
                        <Link
                            className={
                                isPathActive(`/${data.to}`)
                                    ? "nav-link active"
                                    : "nav-link"
                            }
                            
                            to={`/${data.to}`}
                        >
                            {data.name}
                        </Link>
                    </li>
                ))
            }
        </ul>
        </div>
    )
}

export default ContentUrls